<template>
  <div class="guide-item">
    <div class="head" v-if="!isFirst">
      <a-icon type="small-dash" />
      <div class="head-center">
        <a-icon v-if="listData.move_time" type="clock-circle" />
        <a-icon v-if="listData.music_url" type="sound" />
        <a-icon v-if="listData.content" type="align-left" />
      </div>
      <a-icon type="small-dash" />
    </div>
    <div class="last" @click="onSelect">
      <div :class="[selected.point_id === listData.point_id ? 'active' : 'last-top']">{{index}}</div>
      <div class="title">{{listData.title}}</div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    index: {
      required: true,
      type: Number,
    },
    isFirst: {
      default: false,
      type: Boolean,
    },
    listData: {
      type: Object,
      required: true,
    },
    selected: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onSelect() {
      this.$emit("selectedItem", this.listData);
    },
  },
};
</script>

<style lang="less" scoped>
.guide-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;

  .head {
    font-size: 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    height: 47px;
    .head-center {
      display: flex;
      flex-direction: column;
      font-size: 14px;
    }
  }
  .last {
    width: 47px;
    .last-top {
      width: 47px;
      height: 47px;
      border: 2px solid #727272;
      text-align: center;
      line-height: 47px;
      font-size: 14px;
    }
    .title {
      width: 47px;
      height: 20px;
      line-height: 20px;
      color: #ffffff;
      text-align: center;
      font-size: 12px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .active {
    width: 47px;
    height: 47px;
    text-align: center;
    line-height: 47px;
    font-size: 14px;
    border: 2px solid #ffffff;
  }
}
</style>